// extracted by mini-css-extract-plugin
export default {"root":"BlockStores_root__YG819","media":"BlockStores_media__EhNqp","text":"BlockStores_text__OFEzj"};